import { ArrowRight } from 'lucide-react';
import AppLink from '@/components/AppLink/AppLink';
import productArticles from '@/pages/articles/productArticles.json';

const article = productArticles.find(({ slug }) => slug === 'newsletter-engagement');

/** A short band that points visitors to the article on why engagement decides what they earn. */
export default function WhyAtrivial() {
  if (!article) return null;

  return (
    <section
      data-newsletter-section="why_atrivial"
      aria-labelledby="why-atrivial-heading"
      className="border-b border-nl-line bg-nl-paper px-6 py-12 md:py-14"
    >
      <div className="group relative mx-auto grid max-w-6xl items-center gap-8 md:grid-cols-3 md:gap-10">
        <div className="md:col-span-2">
          <h2
            id="why-atrivial-heading"
            className="h-display m-0 text-3xl leading-tight font-medium md:text-4xl"
          >
            Why Atrivial?
          </h2>
          <h3 className="m-0 mt-4 text-xl leading-snug font-semibold text-balance">
            {article.title}
          </h3>
          <p className="m-0 mt-2 max-w-2xl leading-relaxed text-nl-ink/70">
            Your subscriber count gets a sponsor's attention, but engagement decides what they'll
            pay and whether they come back. It's also what keeps readers around long enough to
            upgrade, reply or recommend you.
          </p>
          <AppLink
            to={article.path}
            className="mt-3 inline-flex min-h-11 items-center gap-2 font-semibold text-nl-ink underline decoration-nl-line underline-offset-4 group-hover:decoration-nl-ink after:absolute after:inset-0 after:rounded-2xl focus-visible:outline-none focus-visible:after:outline-2 focus-visible:after:outline-offset-4 focus-visible:after:outline-nl-ink"
          >
            Read the full article
            <ArrowRight className="size-4" aria-hidden="true" />
          </AppLink>
        </div>
        {/* Clicks pass through to the article link that covers the whole band. Without this,
            the hover lift raises the image above that link and swallows the click. */}
        <img
          src={article.banner}
          srcSet={article.bannerSrcSet}
          sizes="(min-width: 1200px) 357px, (min-width: 768px) calc((100vw - 128px) / 3), calc(100vw - 48px)"
          alt=""
          width={1280}
          height={720}
          loading="lazy"
          decoding="async"
          className="pointer-events-none aspect-video h-auto w-full rounded-2xl border border-nl-line bg-nl-muted object-cover shadow-nl-pop transition duration-fast group-hover:-translate-y-0.5 group-hover:shadow-card-hover motion-reduce:transition-none motion-reduce:group-hover:translate-y-0"
        />
      </div>
    </section>
  );
}
